<template>
  <div class="Page" :class="[mode]">
    <slot />
    <Breadcrumbs v-if="!!breadcrumbs.length" :breadcrumbs="breadcrumbs" />
  </div>
</template>

<script lang="ts">
import { defineNuxtComponent } from '#app'
import type { Breadcrumb } from '@/types/breadcrumb'
import Breadcrumbs from '@/components/shared/Breadcrumbs'

export default defineNuxtComponent({
  components: {
    Breadcrumbs,
  },
  props: {
    breadcrumbs: {
      type: Array as () => Breadcrumb[],
      default: () => [],
    },
    mode: {
      type: String as () => 'default' | 'wide',
      default: 'default'
    }
  },
})
</script>

<style scoped>
.Page {
  width: 100%;
  padding: 12px 16px 36px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
}

.Page.wide {
  padding-left: 0;
  padding-right: 0;
}
</style>
